import { render, staticRenderFns } from "./DepositAddress.vue?vue&type=template&id=4975f8db&"
import script from "./DepositAddress.vue?vue&type=script&lang=js&"
export * from "./DepositAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports